import React from "react";
import classnames from "classnames";
import config from "../../config";
import { Link } from "react-router-dom";
import "./Map.scss";

var _config$otherOptions$ = config.otherOptions.get("masterplan"),
    legend = _config$otherOptions$.legend;

export var Map = function Map(a) {
  var b = a.image,
      c = a.polygons,
      d = a.hovered,
      e = a.onHover,
      f = a.neighbourhood,
      g = a.release,
      h = a.lot,
      i = a.menu,
      j = function onMouseEnter(a) {
    "function" == typeof e && e(a);
  },
      k = function onMouseLeave() {
    "function" == typeof e && e(null);
  },
      l = b.src,
      m = b.width || 1440,
      n = b.height || 972;

  return /*#__PURE__*/React.createElement("div", {
    className: "lfs--map--container"
  }, /*#__PURE__*/React.createElement("img", {
    src: l,
    width: "100%",
    alt: "test"
  }), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0,0,".concat(m, ",").concat(n),
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
      height: "auto"
    }
  }, c.map(function (a) {
    var b = a.name,
        c = a.slug,
        e = a.href,
        f = a.coords,
        g = a.status,
        h = classnames({
      active: c === d
    }, "ta-" + c),
        i = 2 === g ? "sold" : 3 === g ? "builder" : 4 === g ? "hold" : "";
    return void 0 === g || 1 === g || 3 === g || 4 === g ? /*#__PURE__*/React.createElement(Link, {
      key: e + b,
      to: e,
      className: classnames(h, i),
      onMouseEnter: function onMouseEnter() {
        return j(c);
      },
      onMouseLeave: function onMouseLeave() {
        return k(c);
      }
    }, /*#__PURE__*/React.createElement("polygon", {
      points: f,
      alt: b
    })) : 2 === g ? /*#__PURE__*/React.createElement("polygon", {
      key: f,
      points: f,
      alt: b,
      className: i
    }) : 3 === g ? /*#__PURE__*/React.createElement("polygon", {
      key: f,
      points: f,
      alt: b,
      className: i
    }) : /*#__PURE__*/React.createElement("polygon", {
      key: f,
      points: f,
      alt: b
    });
  })), (f || g) && !h && legend.length ? /*#__PURE__*/React.createElement("div", {
    className: "lfs--map--legend"
  }, legend.map(function (a, b) {
    var c = a.label;
    if (!c) return null;
    var d = c.toLowerCase().replace(/ /g, "_");
    return /*#__PURE__*/React.createElement("span", {
      key: "".concat(d, "-").concat(b),
      className: "lfs--map--legend__".concat(d)
    }, c);
  })) : null);
};
export default Map;